import { Element } from 'dbweb-core';

export class TreeNode {
	iconName?: string;
	color?: string;
	children?: TreeNode[] = [];
	ele: Element;
	constructor(public name: string, public parent: TreeNode) {}
	title(): string {
		if (this.ele) {
			return this.ele.title();
		}
		if (this.name.search(/[0-9]{2}\./) > -1) {
			return this.name.substr(3);
		}
		return this.name;
	}
	// å¼ºå¶åå»ºä¸ä¸ªèç¹ï¼è·¯å¾ä¸çç¶èç¹å¦æä¸å­å¨ååå»ºï¼è¿åæç»çèç¹
	forceCreate(paths: string[], ele: Element): TreeNode {
		if (paths.length === 0) {
			return null;
		}
		const val = paths.shift();
		// éè¦æåº
		const idx = this.children.findIndex(item => val.localeCompare(item.name) <= 0);
		let node = new TreeNode(val, this);
		if (idx === -1) {
			this.children.push(node);
		} else if (this.children[idx].name === val) {
			node = this.children[idx];
		} else {
			this.children.splice(idx, 0, node);
		}
		if (paths.length === 0) {
			node.ele = ele;
			return node;
		} else {
			return node.forceCreate(paths, ele);
		}
	}
}
